import { Section, SectionType } from './section';

const SUPPORTED_FORMAT_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

export interface ImageSection extends Section {
    type: SectionType.image;
    width: number;
    height: number;
    isLinkable?: boolean; // Added 23/10/18, older templates don't have this property.
    link: string;
    locationType: 'external' | 'local';
    location: string | null;
    originalLocation: string | null;
}

export function isImageSection(section?: Section): section is ImageSection {
    const newLocal = !!section && section.type === SectionType.image;
    return newLocal;
}

export function isSupportedFormat(fileType: string): boolean {
    return SUPPORTED_FORMAT_MIME_TYPES.includes(fileType);
}
